/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_LabelInputs */

const en_us2_workout_logging_bar_label = /** @type {(inputs: Workout_Logging_Bar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bar`)
};

const pt_br2_workout_logging_bar_label = /** @type {(inputs: Workout_Logging_Bar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra`)
};

const es_419_workout_logging_bar_label = /** @type {(inputs: Workout_Logging_Bar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra`)
};

const pt_pt2_workout_logging_bar_label = /** @type {(inputs: Workout_Logging_Bar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra`)
};

const fr_fr2_workout_logging_bar_label = /** @type {(inputs: Workout_Logging_Bar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barre`)
};

const de_de2_workout_logging_bar_label = /** @type {(inputs: Workout_Logging_Bar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stange`)
};

const it_it2_workout_logging_bar_label = /** @type {(inputs: Workout_Logging_Bar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilanciere`)
};

/**
* | output |
* | --- |
* | "Bar" |
*
* @param {Workout_Logging_Bar_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_label = /** @type {((inputs?: Workout_Logging_Bar_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_label(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_label(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_label(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_label(inputs)
	return en_us2_workout_logging_bar_label(inputs)
});
export { workout_logging_bar_label as "workout-logging.bar_label" }